export const PORTFOLIO = [
  {
    id: "rise",
    name: "Rise Chain",
    tag: "Layer 2",
    url: "https://risechain.com",
    tw: "risechain",
    desc: "High performance on-chain exchange and EVM L2",
    stage: "Seed 2024",
    color: "#a855f7",
  },
  {
    id: "symbiotic",
    name: "Symbiotic",
    tag: "Universal Staking",
    url: "https://symbiotic.fi",
    tw: "symbioticfi",
    desc: "Onchain collateral markets infrastructure",
    stage: "Series A 2025",
    color: "#0050AE",
  },
  {
    id: "hyperbeat",
    name: "Hyperbeat",
    tag: "Yield Infrastructure",
    url: "https://hyperbeat.org",
    tw: "hyperbeat",
    desc: "Hyperliquid-native neobank",
    stage: "Seed 2025",
    color: "#ec4899",
  },
];
